import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {filterArticle_template} from "./filterArticle_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";

declare var ko: any;

export class searchQuery_template extends vnTemplate{

    public filterDataDates: filterDate_template;
    public filterPublishedDates: filterDate_template;
    public brandsFilter: multipleSelector_template;
    public filterInitiatives: multipleSelector_template;
    public filterNetworkCategories: multipleSelector_template;
    public filterIntents: multipleSelector_template;
    public filterContentTypes: multipleSelector_template;
    public filterUsers: filterAutoComplete_template;
    public filterArticle: filterArticle_template;
    public simpleFilter: filterSimple_template;
    public pagination: pagination_template;
    public disablerDropdown: filterDropdown_template;
    public presetFilter: presetFilter_template;
    protected exportDataCsv: exportDataCsv;

    readonly viewModes = [
        { "id": "total", "name": "total"},
        { "id": "detailed", "name": "detailed"},
        { "id": "searchAppearance", "name": "search appearance"}
    ];

    //
    // implementation of base class [vnTemplate]
    protected getTemplateHtml(): string{

        return  `  
                <div class="sub-header w-justify">
                    ` + this.presetFilter.getHtmlBuild() + `
               
                    <div class="w-left">
                        <div>`+ this.brandsFilter.getHtmlBuild() +`</div>
                        <div>`+ this.filterInitiatives.getHtmlBuild() +`</div>
                        <div>`+ this.filterNetworkCategories.getHtmlBuild() +`</div>
                        <div>`+ this.filterIntents.getHtmlBuild() +`</div>
                        <div>`+ this.filterContentTypes.getHtmlBuild() +`</div>
                    <!-- ko ifnot: viewModeSelected() == 'searchAppearance' -->
                        <div>`+ this.filterUsers.getHtmlBuild() +`</div>
                        <div>`+ this.filterArticle.getHtmlBuild() +`</div>
                    <!-- /ko -->
                        <div>` + this.filterDataDates.getHtmlBuild() + `</div>
                    <!-- ko ifnot: viewModeSelected() == 'searchAppearance' -->
                        <div data-bind="css: {disabledDiv: !enabledPublishedDatePicker()}">` + this.filterPublishedDates.getHtmlBuild() + `</div>
                        <div>` + this.disablerDropdown.getHtmlBuild() + `</div>
                    <!-- /ko -->
                        <div class="dropdown select-single">
                            <label class="form-label" for="">View Mode</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelectedText"></button>
                            
                            <div class="dropdown-list"> 
                                <div class="w-form">   
                                    <div class="form-group" data-bind="foreach: viewModes">
                                        <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                        <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                         </div>
                    </div>
             
                </div>            
                
                <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected">
                        <div id="selected-brands"></div>
                        <div id="selected-initiatives"></div>
                        <div id="selected-network-categories"></div>
                        <div id="selected-intent"></div>
                        <div id="selected-contentType"></div>
                    </div>
                </div> 
                
                <!-- ko ifnot: viewModeIsChanging() -->
                    <!-- ko ifnot: viewModeSelected() === 'searchAppearance' -->
                        <div class="highlight-page" data-bind="with:searchQueryTotals">
                            <div class="highlight-item">
                                <span class="item-title">Impressions</span>
                                <strong class="item-value icon i-impression" data-bind="text: Number(impressions).toLocaleString('en-us')"></strong>
                            </div>
                            <div class="highlight-item">
                                <span class="item-title">Clicks</span>
                                <strong class="item-value icon i-click" data-bind="text: Number(clicks).toLocaleString('en-us')"></strong>
                            </div>
                            <div class="highlight-item">
                                <span class="item-title">CTR</span>
                                <strong class="item-value icon i-click-t" data-bind="text: ctr"></strong>
                            </div>
                            <div class="highlight-item">
                                <span class="item-title">Average Position</span>
                                <strong class="item-value icon i-podium" data-bind="text: averagePosition"></strong>
                            </div>
                            <div class="highlight-item">
                                <span class="item-title">Total Pages</span>
                                <strong class="item-value icon i-page" data-bind="text:  Number(totalPages).toLocaleString('en-us')"></strong>
                            </div>
                        </div>
                        
                        
                        <div class="list-header w-justify">
                           
                            <div class="w-left">
                                <h2 class="section-title icon i-keywords">Search Query</h2>
                            </div>
                            <div class="w-center"> 
                                ` + this.simpleFilter.getHtmlBuild() + `
                            </div>
                            <div class="w-right"> 
                                ` + this.pagination.getHtmlBuild() + `
                                
                                <!-- ko if: viewModeSelected() == 'detailed' -->
                                <button class="btn icon highlight i-export" type="button" data-bind="event: { click: onExportCsv}">Export</button>
                                <!-- /ko -->
                            </div>
                        </div>
                        
                        <div class="w-list-results content_buckets" data-bind="css: { loading: isLoading }">
                                               
                            <table class="list-results list-logs" id="list-results">
                                <thead>
                                    <input data-bind="value: orderBy" type="hidden">
                                    <input data-bind="value: orderByDirection" type="hidden">
                                    <tr>
                                        <th><span>Query</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'publishDate') }, css: { 'list-sort-desc': orderByAndDirection()=='publishDate_DESC', 'list-sort-asc': orderByAndDirection()=='publishDate_ASC' }" class="icon i-dropdown-simple">publish date</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'page') }, css: { 'list-sort-desc': orderByAndDirection()=='page_DESC', 'list-sort-asc': orderByAndDirection()=='page_ASC' }" class="icon i-dropdown-simple">page</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }" class="icon i-dropdown-simple">title</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'initiative') }, css: { 'list-sort-desc': orderByAndDirection()=='initiative_DESC', 'list-sort-asc': orderByAndDirection()=='initiative_ASC' }" class="icon i-dropdown-simple">initiative</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'networkCategory') }, css: { 'list-sort-desc': orderByAndDirection()=='networkCategory_DESC', 'list-sort-asc': orderByAndDirection()=='networkCategory_ASC' }" class="icon i-dropdown-simple">network category</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'total'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'intent') }, css: { 'list-sort-desc': orderByAndDirection()=='intent_DESC', 'list-sort-asc': orderByAndDirection()=='intent_ASC' }" class="icon i-dropdown-simple">intent</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'total'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentType') }, css: { 'list-sort-desc': orderByAndDirection()=='contentType_DESC', 'list-sort-asc': orderByAndDirection()=='contentType_ASC' }" class="icon i-dropdown-simple">content type</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'total'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'author') }, css: { 'list-sort-desc': orderByAndDirection()=='author_DESC', 'list-sort-asc': orderByAndDirection()=='author_ASC' }" class="icon i-dropdown-simple">author</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'total'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'juniorEditor') }, css: { 'list-sort-desc': orderByAndDirection()=='juniorEditor_DESC', 'list-sort-asc': orderByAndDirection()=='juniorEditor_ASC' }" class="icon i-dropdown-simple">Jr Editor</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'total'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'editor') }, css: { 'list-sort-desc': orderByAndDirection()=='editor_DESC', 'list-sort-asc': orderByAndDirection()=='editor_ASC' }" class="icon i-dropdown-simple">Sr Editor</span></th>
                                        
                                        <th data-bind="visible: viewModeSelected() == 'detailed'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'searchClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='searchClicks_DESC', 'list-sort-asc': orderByAndDirection()=='searchClicks_ASC' }" class="icon i-dropdown-simple">search clicks</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'detailed'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'searchImpressions') }, css: { 'list-sort-desc': orderByAndDirection()=='searchImpressions_DESC', 'list-sort-asc': orderByAndDirection()=='searchImpressions_ASC' }" class="icon i-dropdown-simple">search impressions</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'detailed'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'searchCtr') }, css: { 'list-sort-desc': orderByAndDirection()=='searchCtr_DESC', 'list-sort-asc': orderByAndDirection()=='searchCtr_ASC' }" class="icon i-dropdown-simple">search ctr</span></th>
                                        
                                        <th data-bind="visible: viewModeSelected() == 'total'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'clicks') }, css: { 'list-sort-desc': orderByAndDirection()=='clicks_DESC', 'list-sort-asc': orderByAndDirection()=='clicks_ASC' }" class="icon i-dropdown-simple">clicks</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'total'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'impressions') }, css: { 'list-sort-desc': orderByAndDirection()=='impressions_DESC', 'list-sort-asc': orderByAndDirection()=='impressions_ASC' }" class="icon i-dropdown-simple">impressions</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'total'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'ctr') }, css: { 'list-sort-desc': orderByAndDirection()=='ctr_DESC', 'list-sort-asc': orderByAndDirection()=='ctr_ASC' }" class="icon i-dropdown-simple">ctr</span></th>
                                        
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'averagePosition') }, css: { 'list-sort-desc': orderByAndDirection()=='averagePosition_DESC', 'list-sort-asc': orderByAndDirection()=='averagePosition_ASC' }" class="icon i-dropdown-simple">average position</span></th>
        
                                        <th data-bind="visible: viewModeSelected() == 'total'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'clickDistribution') }, css: { 'list-sort-desc': orderByAndDirection()=='clickDistribution_DESC', 'list-sort-asc': orderByAndDirection()=='clickDistribution_ASC' }" class="icon i-dropdown-simple">Google Distribution (Sea./Dis./GN)</span></th>
                                        
                                        <th data-bind="visible: viewModeSelected() == 'detailed'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'discoverClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='discoverClicks_DESC', 'list-sort-asc': orderByAndDirection()=='discoverClicks_ASC' }" class="icon i-dropdown-simple">discover clicks</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'detailed'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'discoverImpressions') }, css: { 'list-sort-desc': orderByAndDirection()=='discoverImpressions_DESC', 'list-sort-asc': orderByAndDirection()=='discoverImpressions_ASC' }" class="icon i-dropdown-simple">discover impressions</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'detailed'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'discoverCtr') }, css: { 'list-sort-desc': orderByAndDirection()=='discoverCtr_DESC', 'list-sort-asc': orderByAndDirection()=='discoverCtr_ASC' }" class="icon i-dropdown-simple">discover ctr</span></th>
                                        
                                        <th data-bind="visible: viewModeSelected() == 'detailed'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'googleNewsClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='googleNewsClicks_DESC', 'list-sort-asc': orderByAndDirection()=='googleNewsClicks_ASC' }" class="icon i-dropdown-simple">google News clicks</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'detailed'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'googleNewsImpressions') }, css: { 'list-sort-desc': orderByAndDirection()=='googleNewsImpressions_DESC', 'list-sort-asc': orderByAndDirection()=='googleNewsImpressions_ASC' }" class="icon i-dropdown-simple">google News impressions</span></th>
                                        <th data-bind="visible: viewModeSelected() == 'detailed'"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'googleNewsCtr') }, css: { 'list-sort-desc': orderByAndDirection()=='googleNewsCtr_DESC', 'list-sort-asc': orderByAndDirection()=='googleNewsCtr_ASC' }" class="icon i-dropdown-simple">google News ctr</span></th>
                                        
                                        
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: searchQuery">
                                    <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-selected': selected, 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                        <th>
                                        <!-- ko if: row !== 'Total' -->
                                        <button data-bind="event:{click: $parent.onClickGetKeywords}" class="btn icon icon-only i-keywords" type="button"></button>
                                        <!-- /ko -->
                                        <!-- ko if: row === 'Total' -->
                                        <span>Total</span>
                                        <!-- /ko -->
                                        </th>
                                        <td><span class="no-wrap" data-bind="text: publishDate"></span></td>
                                        <td>
                                        <!-- ko if: page -->
                                        <a class="icon i-ext-link" data-bind="attr: {href: page}, text: page" target="_blank"></a>
                                        <!-- /ko -->
                                        </td>
                                        <td class=""><span data-bind="text: title"></span></td>
                                        <td class=""><span data-bind="text: initiative"></span></td>
                                        <td class="cap"><span data-bind="text: networkCategory"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'total'" class=""><span data-bind="text: intent"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'total'" class=""><span data-bind="text: contentType"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'total'" class=""><span data-bind="text: author"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'total'" class=""><span data-bind="text: juniorEditor"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'total'" class=""><span data-bind="text: editor"></span></td>
                                        
                                        <td data-bind="visible: $parent.viewModeSelected() == 'detailed'" class="align-right"><span data-bind="text: Number(searchClicks).toLocaleString('en-us')"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'detailed'" class="align-right"><span data-bind="text: Number(searchImpressions).toLocaleString('en-us')"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'detailed'" class="align-right"><span data-bind="text: searchCtr"></span></td>       
                    
                                        <td data-bind="visible: $parent.viewModeSelected() == 'total'" class="align-right"><span data-bind="text: Number(clicks).toLocaleString('en-us')"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'total'" class="align-right"><span data-bind="text: Number(impressions).toLocaleString('en-us')"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'total'" class="align-right"><span data-bind="text: ctr"></span></td>         
                                        
                                        <td class="align-right"><span data-bind="text: averagePosition"></span></td>                 
        
                                        <td data-bind="visible: $parent.viewModeSelected() == 'total'" class="align-right"><span data-bind="text: clickDistribution"></span></td>
                                        
                                        <td data-bind="visible: $parent.viewModeSelected() == 'detailed'" class="align-right"><span data-bind="text: Number(discoverClicks).toLocaleString('en-us')"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'detailed'" class="align-right"><span data-bind="text: Number(discoverImpressions).toLocaleString('en-us')"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'detailed'" class="align-right"><span data-bind="text: discoverCtr"></span></td>
                                               
                                        <td data-bind="visible: $parent.viewModeSelected() == 'detailed'" class="align-right"><span data-bind="text: Number(googleNewsClicks).toLocaleString('en-us')"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'detailed'" class="align-right"><span data-bind="text: Number(googleNewsImpressions).toLocaleString('en-us')"></span></td>
                                        <td data-bind="visible: $parent.viewModeSelected() == 'detailed'" class="align-right"><span data-bind="text: googleNewsCtr"></span></td>  
                                               
                                                 
                                    </tr>
                                <tbody>
                            </table>
                        </div>
                        
                        <div data-bind="css: {'is-open': isDrawerOpen, loading: isDrawerLoading}" class="drawer search-query">
                            <div class="drawer-notification" data-bind="event: { click: toggleDrawer }">
                                <strong data-bind="text: keywordPage" class="icon i-keywords">Query</strong>
                                <button data-bind="css: {'open': isDrawerOpen}" class="btn icon i-dropdown-simple " type="button"></button>
                            </div> 
                            <div class="scroll">
                                <table class="list-results" id="list-results">
                                    <thead>
                                        <input data-bind="value: orderBy" type="hidden">
                                        <input data-bind="value: orderByDirection" type="hidden">
                                        <tr>                               
                                            <th><span>query</span></th>
                                            <th><span>clicks</span></th>
                                            <th><span>clicks percentage</span></th>
                                            <th><span>impressions</span></th>
                                            <th><span>ctr</span></th>
                                            <th><span>average position</span></th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="foreach: searchQueryKeywordData">
                                    <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, 'keywords' + $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf('keywords' + $index()) !== -1}">
                                            <td class=""><span data-bind="text: keyword"></span></td>
                                            <td class=""><span data-bind="text: Number(clicks).toLocaleString('en-us')"></span></td>
                                            <td class=""><span data-bind="text: percentageClicks"></span></td>
                                            <td class=""><span data-bind="text: Number(impressions).toLocaleString('en-us')"></span></td>
                                            <td class=""><span data-bind="text: ctr"></span></td>
                                            <td class=""><span data-bind="text: averagePosition"></span></td>      
                                        </tr>
                                    <tbody>
                                </table>
                            </div>
                        </div>
                    <!-- /ko -->
                    <!-- ko if: viewModeSelected() == 'searchAppearance' -->
                        <div class="list-header w-justify">
                            
                            <div class="w-right">
                                ` + this.pagination.getHtmlBuild() + `
                                <button class="btn icon highlight i-export" type="button" data-bind="event: { click: onExportCsv}">Export</button>
                            </div>
                        </div>
                        
                        <div class="w-list-results content_buckets" data-bind="css: { loading: isLoading }">
                                               
                            <table class="list-results list-logs" id="list-results">
                                <thead>
                                    <input data-bind="value: orderBy" type="hidden">
                                    <input data-bind="value: orderByDirection" type="hidden">
                                    <tr>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleTitle') }, css: { 'list-sort-desc': orderByAndDirection()=='articleTitle_DESC', 'list-sort-asc': orderByAndDirection()=='articleTitle_ASC' }" class="icon i-dropdown-simple">title</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'productSnippetClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='productSnippetClicks_DESC', 'list-sort-asc': orderByAndDirection()=='productSnippetClicks_ASC' }" class="icon i-dropdown-simple">product snippet clicks</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'reviewSnippetClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='reviewSnippetClicks_DESC', 'list-sort-asc': orderByAndDirection()=='reviewSnippetClicks_ASC' }" class="icon i-dropdown-simple">review snippet clicks</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'videoClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='videoClicks_DESC', 'list-sort-asc': orderByAndDirection()=='videoClicks_ASC' }" class="icon i-dropdown-simple">video clicks</span></th>
                                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='totalClicks_DESC', 'list-sort-asc': orderByAndDirection()=='totalClicks_ASC' }" class="icon i-dropdown-simple">total clicks</span></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: searchAppearancePages">
                                <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, 'searchAppearance' + $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf('searchAppearance' + $index()) !== -1}">
                                        <!--<td class=""><span data-bind="text: articleTitle"></span></td>-->
                                        <td><a class="icon i-ext-link" data-bind="attr: {href: articleLink}, text: articleTitle" target="_blank"></a></td>
                                        <td class=""><span data-bind="text: productSnippetClicks"></span></td>
                                        <td class=""><span data-bind="text: reviewSnippetClicks"></span></td>
                                        <td class=""><span data-bind="text: videoClicks"></span></td>
                                        <td class=""><span data-bind="text: totalClicks"></span></td>
                                    </tr>
                                <tbody>
                            </table>
                        </div>
                    <!-- /ko -->
                <!-- /ko -->
            `;
    }

    //
    // implementation of base class [vnTemplate]
    protected getTemplateName(): string{
        return "searchQuery_template";
    }

    //
    // implementation of base class [vnTemplate]
    protected getMainElementClasses(): Array<string>{
        return [""];
    }

    //
    // implementation of base class [vnTemplate]
    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('search_query');

        let dateEnd = new Date();
        dateEnd.setDate(dateEnd.getDate()-2);

        let dateStart = new Date();
        dateStart.setDate(dateStart.getDate()-9);

        this.filterDataDates = new filterDate_template("filterDataDates", this.getTemplateViewModel(), this.caller);
        this.filterDataDates.setStartPickerId('startDataDate');
        this.filterDataDates.setEndPickerId('endDataDate');
        this.filterDataDates.setDateRange(dateStart, dateEnd);

        this.filterPublishedDates = new filterDate_template("filterPublishedDates", this.getTemplateViewModel(), this.caller);
        this.filterPublishedDates.setStartPickerId('startPublishedDate');
        this.filterPublishedDates.setEndPickerId('endPublishedDate');
        this.filterPublishedDates.setDateRange(dateStart, dateEnd);

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setLabel("brands");
        this.brandsFilter.setFilterContainerClass('margin-neg');
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLogoEnabled(true);

        this.filterInitiatives = new multipleSelector_template("filterInitiatives", this.getTemplateViewModel(), this.caller);
        this.filterInitiatives.setLabel("Mappings");
        this.filterInitiatives.setFilterContainerClass('margin-neg');
        this.filterInitiatives.setTagContainerId('selected-initiatives');
        this.filterInitiatives.setTagContainerCaption('Selected mappings:');

        this.filterNetworkCategories = new multipleSelector_template("filterNetworkCategories", this.getTemplateViewModel(), this.caller);
        this.filterNetworkCategories.setLabel("network categories");
        this.filterNetworkCategories.setTagContainerId('selected-network-categories');
        this.filterNetworkCategories.setTagContainerCaption('Selected network categories:');

        this.filterIntents = new multipleSelector_template("filterIntents", this.getTemplateViewModel(), this.caller);
        this.filterIntents.setLabel("Intents");
        this.filterIntents.setFilterContainerClass('margin-neg');
        this.filterIntents.setTagContainerId('selected-intent');
        this.filterIntents.setTagContainerCaption('Selected intent:');

        this.filterContentTypes = new multipleSelector_template("filterContentTypes", this.getTemplateViewModel(), this.caller);
        this.filterContentTypes.setLabel("content type");
        this.filterContentTypes.setTagContainerId('selected-contentType');
        this.filterContentTypes.setTagContainerCaption('Selected content type:');

        this.simpleFilter = new filterSimple_template("simpleFilter", this.getTemplateViewModel(), this.caller);

        this.filterUsers = new filterAutoComplete_template("filterUsers", this.getTemplateViewModel(), this.caller);
        this.filterUsers.setIsVisible(1);
        this.filterUsers.setPlaceHolderText("User Search");

        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);

        this.disablerDropdown = new filterDropdown_template('disablerDropdown', this.getTemplateViewModel(), this.caller);
        this.initDisablerDropdown();

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;

        this.exportDataCsv = new exportDataCsv();
    }

    private initDisablerDropdown(): void {

        this.disablerDropdown.setLabel("Disabler");
        let options: Array<any> = [];

        options.push({"id" : 0, "name" : 'Disable Publish Dates'});
        options.push({"id" : 1, "name" : 'Enable Publish Dates'});
        this.disablerDropdown.setOptions(options);
    }

    //
    // implementation of base class [vnTemplate]
    public buildViewModel(){

        // define the viewModel data/ functions
        let myself = this;

        return  {
            orderBy: ko.observable(""),
            keywordPage: ko.observable("Keywords"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("searchClicks_DESC"),
            filterKeyword: ko.observable(""),
            isDrawerOpen: ko.observable(0),
            isDrawerLoading: ko.observable(0),
            isLoading: ko.observable(0),
            searchQuery: ko.observableArray([]),
            searchAppearancePages: ko.observableArray([]),
            searchQueryTotals: ko.observable({clicks: "0", impressions: "0", ctr: "0%", averagePosition: "0", totalPages: "0"}),
            searchQueryKeywordData: ko.observableArray([]),
            enabledPublishedDatePicker: ko.observable(false),
            viewModes                  : ko.observableArray([]),
            viewModeIsChanging         : ko.observable(false),
            viewModeSelected           : ko.observable("total"),
            viewModeSelectedText       : ko.observable("Total"),
            selectedRows               : ko.observableArray([]),
            onClickReorder : function(value, data, event){ myself.onClickReorder(value, data, event); },
            onClickGetKeywords : function(data){ myself.onClickGetKeywords(data); },
            toggleDrawer: function(){ myself.toggleDrawer(); },
            onViewModeChange: function (data) {
                myself.onViewModeChange(data);
            },
            onExportCsv: function(){ myself.onExportCsv(); },
            exportData: function(data,fileName){ myself.exportData(data, fileName); },
            onClickRowClick             : function(index, data){ myself.onClickRowClick(index); return true; },
        };
    }

    public getViewModelForRequest() {

        let orderBy = this.viewModel.searchQuery.orderBy();
        if(orderBy == ''){

            if(this.viewModel.searchQuery.viewModeSelected() == 'searchAppearance') {

                orderBy = 'totalClicks';
            }
            else {

                orderBy = 'searchClicks';
            }
        }

        return {
            orderBy : orderBy,
            orderByDirection : this.viewModel.searchQuery.orderByDirection(),
            pagination: this.getTemplateViewModel().pagination,
            enabledPublishedDates: this.getTemplateViewModel().enabledPublishedDatePicker(),
            filter:{
                dateDataFilterType: this.viewModel.searchQuery.filterDataDates.selectedFilter(),
                startDataDate: this.viewModel.searchQuery.filterDataDates.startDate(),
                endDataDate: this.viewModel.searchQuery.filterDataDates.endDate(),
                startDataDateRange: this.viewModel.searchQuery.filterDataDates.fromRange(),
                endDataDateRange: this.viewModel.searchQuery.filterDataDates.toRange(),
                publishedDateFilterType: this.viewModel.searchQuery.filterPublishedDates.selectedFilter(),
                startPublishedDate: this.viewModel.searchQuery.filterPublishedDates.startDate(),
                endPublishedDate: this.viewModel.searchQuery.filterPublishedDates.endDate(),
                startPublishedDateRange: this.viewModel.searchQuery.filterPublishedDates.fromRange(),
                endPublishedDateRange: this.viewModel.searchQuery.filterPublishedDates.toRange(),
                brands: this.viewModel.searchQuery.brandsFilter.selectedItems(),
                initiatives: this.viewModel.searchQuery.filterInitiatives.selectedItems(),
                networkCategories: this.viewModel.searchQuery.filterNetworkCategories.selectedItems(),
                intents: this.viewModel.searchQuery.filterIntents.selectedItems(),
                contentTypes: this.viewModel.searchQuery.filterContentTypes.selectedItems(),
                keywords: this.viewModel.searchQuery.simpleFilter.filterKeyword(),
                user: this.viewModel.searchQuery.filterUsers.idSelectedItem(),
                userName: this.viewModel.searchQuery.filterUsers.nameSelectedItem(),
                keywordPage: this.viewModel.searchQuery.keywordPage(),
                viewMode: this.viewModel.searchQuery.viewModeSelected(),
                article: this.getTemplateViewModel().filterArticle.articleObjLite(),
            }
        }
    }

    private onExportCsv(){

        this.caller.getExportData();
    }

    public setExportData(exportData, viewMode){

        let exportDataView = [];
        let fileName = "";

        //
        // exportDataViewRow -> Key : Column Name for the file
        // exportDataViewRow -> Value : Column Data for the file
        // exportDataView -> Object with all data for the file

        if (viewMode == 'searchAppearance') {
            for (let exportDataRow of exportData){

                let exportDataViewRow = [];

                exportDataViewRow["Article Id"] = exportDataRow.idArticle;
                exportDataViewRow["Article Title"] = exportDataRow.articleTitle;
                exportDataViewRow["Permalink"] = exportDataRow.articleLink;
                exportDataViewRow["Product Snippet Clicks"] = Number(exportDataRow.productSnippetClicks).toLocaleString('en-EG');
                exportDataViewRow["Review Snippet Clicks"] = Number(exportDataRow.reviewSnippetClicks).toLocaleString('en-EG');
                exportDataViewRow["Video Clicks"] = Number(exportDataRow.videoClicks).toLocaleString('en-EG');
                exportDataViewRow["Total Clicks"] = Number(exportDataRow.totalClicks).toLocaleString('en-EG');

                exportDataView.push(exportDataViewRow);

            }

            fileName = "page_searchAppearance_export.csv";
        }
        else if (viewMode == 'detailed') {
            for (let exportDataRow of exportData) {

                let exportDataViewRow = [];
    
                exportDataViewRow["Publish Date"] = exportDataRow.publishDate;
                exportDataViewRow["Page"] = exportDataRow.page;
                exportDataViewRow["Article Title"] = exportDataRow.title;
                exportDataViewRow["Initiative"] = exportDataRow.initiative;
                exportDataViewRow["Network Category"] = exportDataRow.networkCategory;
                exportDataViewRow["Search Clicks"] = Number(exportDataRow.searchClicks).toLocaleString('en-EG');
                exportDataViewRow["Search Impressions"] = Number(exportDataRow.searchImpressions).toLocaleString('en-EG');
                exportDataViewRow["Search Ctr"] = exportDataRow.searchCtr;
                exportDataViewRow["Average Position"] = exportDataRow.averagePosition;
                exportDataViewRow["Discover Clicks"] = Number(exportDataRow.discoverClicks).toLocaleString('en-EG');
                exportDataViewRow["Discover Impressions"] = Number(exportDataRow.discoverImpressions).toLocaleString('en-EG');
                exportDataViewRow["Discover Ctr"] = exportDataRow.discoverCtr;
                exportDataViewRow["Google News Clicks"] = Number(exportDataRow.googleNewsClicks).toLocaleString('en-EG');
                exportDataViewRow["Google News Impressions"] = Number(exportDataRow.googleNewsImpressions).toLocaleString('en-EG');
                exportDataViewRow["Google News Ctr"] = exportDataRow.googleNewsCtr;
    
                exportDataView.push(exportDataViewRow);
    
            }
    
            fileName = "page_detailed_export.csv";
        }

        this.getTemplateViewModel().exportData(exportDataView, fileName);
    }

    private exportData(data, fileName){

        this.exportDataCsv.exportToCsv(fileName, data);
    }
    

    //
    // implementation of base class [vnTemplate]
    public activateLoading(){

        this.getTemplateViewModel().isLoading(1);
    }

    //
    // implementation of base class [vnTemplate]
    public deactivateLoading(){

        this.getTemplateViewModel().viewModeIsChanging(false);
        this.getTemplateViewModel().isLoading(0);
    }

    public toggleDrawer(){

        this.getTemplateViewModel().isDrawerOpen(!this.getTemplateViewModel().isDrawerOpen());
    }

    public onViewModeChange(data){

        this.getTemplateViewModel().orderBy('');
        this.getTemplateViewModel().viewModeIsChanging(true);
        this.getTemplateViewModel().viewModeSelectedText(data.name);
        this.caller.getSearchQuery();
    }

    //
    // clicks action
    public onClickReorder(value, data, event){

        data.orderBy(value);
        if( data.orderByDirection() == "DESC" ){
            data.orderByDirection("ASC");
        }
        else{
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.reorder();
    }

    //
    // clicks action
    public onClickGetKeywords(data){

        let values = this.getTemplateViewModel().searchQuery();
        for (let value of values) {
            value['selected'] = 0;
        }

        data['selected'] = 1;

        this.getTemplateViewModel().searchQuery([]);
        this.getTemplateViewModel().searchQuery(values);

        this.getTemplateViewModel().isDrawerOpen(1);
        this.getTemplateViewModel().isDrawerLoading(1);
        this.getTemplateViewModel().keywordPage(data.page);
        this.caller.getSearchQueryKeywordData(data.publishDate);
    }

    //build the date Picker calendar
    public buildDatePickerCalendars(){
        this.filterDataDates.buildCalendar();
        this.filterPublishedDates.buildCalendar();
    }

    public setSearchQuery(searchQuery: Array<any>): void{

        for (let query of searchQuery) {
            query['selected'] = 0;
        }
        this.getTemplateViewModel().searchQuery(searchQuery);
    }

    public setSearchAppearancePages(searchAppearancePages: Array<any>): void{

        this.getTemplateViewModel().searchAppearancePages(searchAppearancePages);
    }

    public setSearchQueryTotals(searchQueryTotals): void{

        this.getTemplateViewModel().searchQueryTotals(searchQueryTotals);
    }

    public setSearchQueryKeywordData(searchQueryKeywordData: Array<any>): void{

        this.getTemplateViewModel().searchQueryKeywordData(searchQueryKeywordData);
        this.getTemplateViewModel().isDrawerLoading(0);
    }

    public setFilterBrands(departments): void{

        let groups = [];
        for ( let department of departments){
            let group = {"name" : department.name, "logo" : department.logo, "items" : department.brands};
            groups.push(group);
        }
        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel('Brands');
    }

    public setFilterInitiatives(items){
        for (let item of items){
            item['name'] = item['initiative'];
        }
        this.filterInitiatives.setItems(items);
    }

    public setFilterNetworkCategories(items: Array<{id: number, name: string, networkCategories: Array<any>}>): void{

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.filterNetworkCategories.setMultiSectionItems(groups);
        this.filterNetworkCategories.setLabel('Network Categories');
    }

    public setFilterIntents(filterList: Array<{id: number,name: string}>): void{

        this.filterIntents.setItems(filterList);
    }

    public setFilterContentTypes(items: Array<{id: number, name: string, 'contentTypes': Array<any>}>): void{

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.filterContentTypes.setMultiSectionItems(groups);
        this.filterContentTypes.setLabel('Content Types');
    }

    public setFilterUsers(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        this.filterUsers.setItems(items);
    }

    public setFilterArticles(items){

        this.getTemplateViewModel().filterArticle.articles(items);
    }

    public setEnabledPublishedDatePicker(enable: boolean): void {

        this.getTemplateViewModel().enabledPublishedDatePicker(enable);
    }

    public isPublishDatesPickerEnabled(): boolean {

        let disabled = this.disablerDropdown.getTemplateViewModel().selectedOption();

        return (disabled != 0);
    }

    public setViewModesItems(){
        this.getTemplateViewModel().viewModes(this.viewModes);
    }


    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['filter']['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterInitiatives, params['filter']['initiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterNetworkCategories, params['filter']['networkCategories']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterIntents, params['filter']['intents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterContentTypes, params['filter']['contentTypes']);

        this.presetFilter.setAutocompletePresetFilter(this.filterUsers, params['filter']['user'], params['filter']['userName']);

        this.filterArticle.setViewModelFromRequest(params['filter']['article']);

        this.presetFilter.setDates(this.filterDataDates, params['filter']['dateDataFilterType'], params['filter']['startDataDate'], params['filter']['endDataDate'], params['filter']['startDataDateRange'], params['filter']['endDataDateRange']);

        this.presetFilter.setDates(this.filterPublishedDates, params['filter']['publishedDateFilterType'], params['filter']['startPublishedDate'], params['filter']['endPublishedDate'], params['filter']['startPublishedDateRange'], params['filter']['endPublishedDateRange']);

        if(typeof params['enabledPublishedDates'] !== 'undefined'){

            this.disablerDropdown.setSelectedOption(params['enabledPublishedDates']);
            this.getTemplateViewModel().enabledPublishedDatePicker(params['enabledPublishedDates']);
        }else{

            this.disablerDropdown.setSelectedOption(null);
            this.disablerDropdown.setSelectedOption(params['enabledPublishedDates']);
        }

        if(typeof params['filter']['keywords'] !== 'undefined'){

            this.simpleFilter.getTemplateViewModel().filterKeyword(params['filter']['keywords']);
        }

        if(typeof params['filter']['viewMode'] !== 'undefined'){

            this.getTemplateViewModel().viewModeSelected(params['filter']['viewMode']);
            this.getTemplateViewModel().viewModeSelectedText(this.presetFilter.getFilterTextFromId(this.viewModes, params['filter']['viewMode']));
        }

    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/searchQuery_template.ts